import { createContext, useContext } from 'react'
import type { AuthUser } from '@/lib/types'

export interface AuthState {
  user: AuthUser | null
  isLoggedIn: boolean
  isLoading: boolean
  /** Mods and admins may edit anything. */
  isModerator: boolean
  isAdmin: boolean
  login: () => void
  logout: () => void
}

export const AuthContext = createContext<AuthState | null>(null)

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>')
  return ctx
}
